import BottomNavBar from './BottomNavBar';
export default BottomNavBar;
